export function setCache(key: string, value: string | [] | {}, sec: number = 31556926) {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        data: value,
        expiry: now.getTime() + (sec * 1000)
    };
    return localStorage.setItem(key, JSON.stringify(item));
}

export function getCache(key: string): (any[] | null) {
    const itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key);
        return null;
    }
    return item.data;
}

export function deleteCache(key: string) {
    return localStorage.removeItem(key);
}

export function sizeCache(): string {
    let allStrings = '';
    for (const key in window.localStorage) {
        if (window.localStorage.hasOwnProperty(key)) {
            allStrings += window.localStorage[key];
        }
    }
    return allStrings ? 3 + ((allStrings.length * 16) / (8 * 1024)).toFixed(2) + ' KB' : 'Empty (0 KB)';
}

export function placeholder(width: number = 0, height: number = 0) {
    return `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 ${width} ${height}' fill='none'><rect width='${width}' height='${height}'></rect></svg>`;
}

export function isNumber(n: any): boolean {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0)
}

export function isTouch(): boolean {
    // @ts-ignore
    return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator?.msMaxTouchPoints > 0);
}

export function uniqueBy(arr: [], prop) {
    return [...new Map(arr.map(m => [m[prop], m])).values()];
}

export function capitalize(s): string {
    if (typeof s !== 'string') {
        return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function objectMap(obj, fn) {
    return Object.fromEntries(
        Object.entries(obj).map(
            ([k, v], i) => [k, fn(v, k, i)]
        )
    );
}


export function throttle(func, delay: number = 300) {
    let timerFlag = null; // Variable to keep track of the timer

    // Returning a throttled version
    return (...args) => {
        if (timerFlag === null) { // If there is no timer currently running
            func(...args); // Execute the main function
            timerFlag = setTimeout(() => { // Set a timer to clear the timerFlag after the specified delay
                timerFlag = null; // Clear the timerFlag to allow the main function to be executed again
            }, delay);
        }
    };
}
